<div class="mb-3">
  <mwe-form-input #email [parentForm]="parentForm" [inputElem]="emailInput" [isLoading]="isLoading" />
  <mwe-form-input-error [parentForm]="parentForm" [inputElem]="emailInput" />
</div>
@if (emailConfirmationInput) {
  <div [hidden]="emailConfirmationInput?.isHidden">
    <mwe-form-input #emailConfirmation [parentForm]="parentForm" [inputElem]="emailConfirmationInput" [isLoading]="isLoading" />
    <mwe-form-input-error [parentForm]="parentForm" [inputElem]="emailConfirmationInput" />
  </div>
}
